import type { TripStatusType } from 'api/swagger';
import { createStore } from './create-store';

export interface ITripFilter {
  statuses?: TripStatusType[];
  userIds?: number[];
  soldToPartners?: boolean;
  loadingWarehouseIds?: number[];
  unloadingWarehouseIds?: number[];
  carrierId?: {
    value: number;
    label?: string;
  };
  createdAt?: {
    from: Date;
    to: Date;
  };
}

type TState = {
  search: string;
  filters?: ITripFilter;
};

type TActions = {
  setSearch: (value: string) => void;
  setFilters: (value: ITripFilter | undefined) => void;
};

export const useTripFiltersStore = createStore<TState & TActions>(
  (set) => ({
    search: '',
    filters: undefined,
    setSearch: (search: string) => set((state) => ({ ...state, search })),
    setFilters: (filters: ITripFilter | undefined) => set((state) => ({ ...state, filters })),
  }),
  'trip-filters-store',
);
